import Vue from "vue";
import Router from "vue-router";
import Student from "../pages/student.vue";

Vue.use(Router);

const downloadIndex = r => require.ensure([], () => r(require('../pages/appDownLoad/downloadIndex.vue')), 'downloadIndex');


const Login = r => require.ensure([], () => r(require('../pages/login.vue')), 'Login');
const reportCenter = r => require.ensure([], () => r(require('../pages/reportCenter/reportCenter.vue')), 'reportCenter');
const receiveManage = r => require.ensure([], () => r(require('../pages/receiveManage/receiveManage.vue')), 'receiveManage');
const shipManage = r => require.ensure([], () => r(require('../pages/shipManage/shipManage.vue')), 'shipManage');
const stockManage = r => require.ensure([], () => r(require('../pages/stockManage/stockManage.vue')), 'stockManage');
// 财务中心
const moneyCenter = r => require.ensure([], () => r(require('../pages/moneyCenter/moneyCenter.vue')), 'moneyCenter');
// 商品管理
const goodManage = r => require.ensure([], () => r(require('../pages/goodManage/goodManage.vue')), 'goodManage');
// 司机管理
const driverManage = r => require.ensure([], () => r(require('../pages/driverManage/driverManage.vue')), 'driverManage');
// 仓库管理
const wareHouseManage = r => require.ensure([], () => r(require('../pages/wareHouseManage/wareHouseManage.vue')), 'wareHouseManage');




const managPages = r => require.ensure([], () => r(require('../pages/managPages/managPages.vue')), 'managPages');
const photoAlbum = r => require.ensure([], () => r(require('../pages/photoAlbum/photoAlbum.vue')), 'photoAlbum');
const rightPart = r => require.ensure([], () => r(require('../pages/managPages/component/rightPart.vue')), 'rightPart');
const router = new Router({
  routes: [
    {
      path: "/downloadIndex",
      name: "downloadIndex",
      component: downloadIndex
    },
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/Student",
      name: "Student",
      component: Student
    },
    {
      path: "/managPages",
      name: "managPages",
      component: managPages,
      children: [
        // 报表中心
        {
          path: "/reportCenter",
          name: "reportCenter",
          component: reportCenter
        },
        // 收货管理
        {
          path: "/receiveManage",
          name: "receiveManage",
          component: receiveManage
        },
        // 发货管理
        {
          path: "/shipManage",
          name: "shipManage",
          component: shipManage
        },
        // 库存管理
        {
          path: "/stockManage",
          name: "stockManage",
          component: stockManage
        },
        // 财务中心
        {
          path: "/moneyCenter",
          name: "moneyCenter",
          component: moneyCenter
        },
        // 商品管理
        {
          path: "/goodManage",
          name: "goodManage",
          component: goodManage
        },
        // 司机管理
        {
          path: "/driverManage",
          name: "driverManage",
          component: driverManage
        },
        // 仓库管理
        {
          path: "/wareHouseManage",
          name: "wareHouseManage",
          component: wareHouseManage
        },
        {
          path: "/photoAlbum",
          name: "photoAlbum",
          component: photoAlbum
        },
        {
          path: "/rightPart",
          name: "rightPart",
          component: rightPart
        },
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path === '/' || to.path === '/downloadIndex') {
    next()
  }
  const user = localStorage.getItem("user")
  if(to.path === '/downloadIndex') {
    next()
  } else if (!user && to.path !== '/') {
    return next("/")
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js